// src/components/shared/LocationSwitcher.jsx
// Segmented Redmond / Kirkland / All Locations switcher.
// Sets the app-wide location (LocationContext), so every screen stays in sync.
import React from 'react';
import { useLocation, LOCATIONS } from '../../contexts/LocationContext';

const LocationSwitcher = () => {
  const { currentLocation, setCurrentLocation } = useLocation();

  return (
    <div style={{ display: 'flex', gap: '0.2rem', backgroundColor: '#f1f5f9', borderRadius: '8px', padding: '0.2rem' }}>
      {Object.values(LOCATIONS).map(loc => (
        <button
          key={loc.id}
          onClick={() => setCurrentLocation(loc.id)}
          style={{
            padding: '0.3rem 0.7rem', border: 'none', borderRadius: '6px',
            fontSize: '0.78rem', fontWeight: currentLocation === loc.id ? '700' : '400',
            backgroundColor: currentLocation === loc.id ? 'white' : 'transparent',
            color: currentLocation === loc.id ? loc.color : '#6b7280',
            cursor: 'pointer',
            boxShadow: currentLocation === loc.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            transition: 'all 0.15s',
          }}
        >
          {loc.label}
        </button>
      ))}
    </div>
  );
};

export default LocationSwitcher;
